import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
// eslint-disable-next-line import/extensions
import { connect } from 'redux-zero/react';

import { actions } from '../../shared/store.js';
import PartnersService from './partners.service.js';
import { Button } from '../../components/ui-toolkit/buttons.js';
import NotImplemented from '../../components/not-implemented/page-not-implemented.js';
import ScrollToTop from '../../shared/utils.js';
import Seo from '../../infrastructure/seo.js';

import './partners-details.scss';

class PartnersDetailsPage extends Component {
	static prefetchData = async language => PartnersService.getPartnersDetailsPage(language);

	state = {
		hasError: false,
	};

	componentDidMount() {
		const { partnersDetailsPageData, setLoading } = this.props;

		ScrollToTop();
		if (!partnersDetailsPageData) {
			this.fetchData();
		} else {
			setLoading(false);
		}
	}

	componentDidUpdate(prevProps) {
		const { language } = this.props;

		ScrollToTop();
		if (language.value !== prevProps.language.value) {
			this.fetchData();
		}
	}

	fetchData() {
		const {
			setLoading,
			language,
			match,
			setPartnersDetailsPageData,
		} = this.props;

		setLoading(true);
		PartnersDetailsPage.prefetchData(language.value, match.params.slug)
			.then((data) => {
				setPartnersDetailsPageData(data);
				setLoading(false);
			})
			.catch(() => {
				setLoading(false);
				this.setState({
					hasError: true,
				});
			});
	}

	render() {
		const {
			partnersDetailsPageData,
			intl: { formatMessage },
			addresses,
			phones,
			generalData,
		} = this.props;
		const { hasError } = this.state;

		const regex = /(<([^>]+)>)/ig;

		if (hasError || !partnersDetailsPageData) {
			return <NotImplemented title="Seeking for Partners" />;
		}

		const {
			title,
			description,
			compensation,
			requiredExperience,
			jobTitle,
			jobDescription,
			expectations,
			submission,
		} = partnersDetailsPageData;

		return (
			<div className="outside">
				<Seo
					title={formatMessage({ id: 'navigation.partners' })}
					description={description && description.replace(regex, '')}
					microdata={`{
									"@context": "https://schema.org",
									"@graph": [
										{
											"@type": "JobPosting",
											"title": "${title}",
											"description": "${description.replace(regex, '') || ''}",
											"hiringOrganization": {
												"@type": "Organization",
												"name": "Inocrowd"
											}
										},
										{
											"@type": "WebApplication",
											"name": "Inocrowd",
											"url": "${process.env.REACT_APP_WEBSITE_ENDPOINT}",
											"applicationCategory": "BusinessApplication",
											"operatingSystem": "Windows, Linux, OSX, iOS, Android",
											"sameAs": [
												"${process.env.REACT_APP_PLATFORM_ENDPOINT}",
												"https://www.facebook.com/InoCrowd/",
												"https://www.linkedin.com/company/inocrowd",
												"https://twitter.com/InoCrowd",
												"https://www.instagram.com/inocrowd",
												"https://www.youtube.com/channel/UC8JotJA9Txz_6NQXWuEwdvQ"
											],
											"provider": {
												"@type": "Organization",
												"name": "Inocrowd",
												${addresses.length > 0 && `
													"address":  "${addresses[0].description.replace(/\n/g, ' ')}",
												`}
												${phones.length > 0 && `
													"contactPoint": {
														"@type": "ContactPoint",
														"telephone": "${phones[0].phoneNumber}",
														"contactType": "customer service"
													},
													"telephone": "${phones[0].phoneNumber}",
												`}
												${generalData && generalData.logo ? `
													"logo": "${process.env.REACT_APP_API_ENDPOINT}${generalData.logo.path}"
												` : ''}
											}
										},
										{
											"@type": "BreadcrumbList",
											"itemListElement": [
												{
													"@type": "ListItem",
													"name": "Inocrowd",
													"position": 1,
													"item": "${process.env.REACT_APP_WEBSITE_ENDPOINT}"
												},
												{
													"@type": "ListItem",
													"name": "${formatMessage({ id: 'navigation.partners' })}",
													"position": 2,
													"item": "${process.env.REACT_APP_WEBSITE_ENDPOINT}/partners"
												}
											]
										}
									]
								}`}
				/>
				<div className="partners-details-section">
					<div className="container container-fluid">
						<div className="section job-title">
							<span>{title}</span>
						</div>
						<div className="specifications">
							<div className="section job-description">
								<div
									className="description"
									// eslint-disable-next-line react/no-danger
									dangerouslySetInnerHTML={{ __html: description }}
								/>
							</div>
							<div className="section responsibilities">
								<div className="title">
									{formatMessage({ id: 'partners.compensation' })}
								</div>
								<div
									className="description"
									// eslint-disable-next-line react/no-danger
									dangerouslySetInnerHTML={{ __html: compensation }}
								/>
							</div>
							<div className="section">
								<div className="title">
									{formatMessage({ id: 'partners.required-experience' })}
								</div>
								<div
									className="description"
									// eslint-disable-next-line react/no-danger
									dangerouslySetInnerHTML={{ __html: requiredExperience }}
								/>
							</div>
							<div className="section">
								<div className="title">
									{formatMessage({ id: 'partners.job-title' })}
								</div>
								<div
									className="description"
									// eslint-disable-next-line react/no-danger
									dangerouslySetInnerHTML={{ __html: jobTitle }}
								/>
							</div>
							<div className="section">
								<div className="title">
									{formatMessage({
										id: 'partners.job-description',
									})}
								</div>
								<div
									className="description"
									// eslint-disable-next-line react/no-danger
									dangerouslySetInnerHTML={{
										__html: jobDescription,
									}}
								/>
							</div>
							<div className="section">
								<div className="title">
									{formatMessage({ id: 'partners.expecations' })}
								</div>
								<div
									className="description"
									// eslint-disable-next-line react/no-danger
									dangerouslySetInnerHTML={{ __html: expectations }}
								/>
							</div>
							<div className="section">
								<div className="title">
									{formatMessage({ id: 'partners.submission' })}
								</div>
								<div
									className="description"
									// eslint-disable-next-line react/no-danger
									dangerouslySetInnerHTML={{ __html: submission }}
								/>
							</div>
						</div>

						<div className="section button-apply-now">
							<Button className="btn-color-theme-2" to="/partners/apply">
								{formatMessage({ id: 'partners.submit-button' })}
							</Button>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

const mapToProps = ({ language, partnersDetailsPageData, addresses, phones, generalData }) => ({
	language,
	partnersDetailsPageData,
	addresses,
	phones,
	generalData,
});
export default connect(
	mapToProps,
	actions,
)(injectIntl(PartnersDetailsPage));

export { PartnersDetailsPage };
